import React, { createContext, FunctionComponent, useMemo } from 'react';
import { InstallationProvider } from './InstallationProvider';
import { PPDefaultInstallationProvider } from 'application/Providers/Installation/CPDefault/PPDefaultInstallationProvider';
import { BRInstallationProvider } from './BuildersRisk/BRInstallationProvider';

export const InstallationProviderContext = createContext<InstallationProvider>({} as InstallationProvider);

interface InstallationProps {
    productType?: string;
}

const Installation: FunctionComponent<InstallationProps> = (props) => {
    const { productType, children } = { ...props };

    const installationProviderValue = useMemo(() => {
        switch (productType) {
            case 'BUILDERS_RISK':
                return new BRInstallationProvider();
            default:
                return new PPDefaultInstallationProvider();
        }
    }, [productType]);

    return (
        <InstallationProviderContext.Provider value={installationProviderValue}>
            {children}
        </InstallationProviderContext.Provider>
    );
};

export default Installation;
